import type { HowItWorksStep } from "@/shared/ui/HowItWorks";

export const REFERRAL_STEPS: HowItWorksStep[] = [
  {
    title: "Укажите партнёрский ID",
    text: "Он выдаётся в партнёрской программе. Без него ссылка работать не будет.",
  },
  {
    title: "Настройте ссылку под задачу",
    text: "Страница входа, список страховых компаний, метки канала и UTM для аналитики.",
  },
  {
    title: "Скопируйте готовую ссылку",
    text: "Скопируйте кнопкой или выделением и разместите её на сайте, в рассылке, соцсетях или мессенджерах.",
  },
  {
    title: "Получайте вознаграждение",
    text: "Переход закрепляется за вами надолго: клиент будет засчитан, даже если оформит полис позже.",
  },
];
